import PauseModal from '../../../modals/pauseModal/PauseModal';
import ProfileModal from '../../../modals/profileModal/ProfileModal';
import ProcedureModal from '../../../modals/procedureModal/ProcedureModal';
import GameResultModal from '../../../modals/gameResultModal/GameResultModal';
import StartGameModal from '../../../modals/startGameModal/StartGameModal';
import LoseModal from '../../../modals/loseModal/LoseModal';
import WinModal from '../../../modals/winModal/WinModal';
import WinBeautyBoxModal from '../../../modals/winBeautyBoxModal/WinBeautyBoxModal';
import Prizes from '../../../pages/prizes/Prizes';
import QuizStartModal from '../../../modals/quizStartModal/QuizStartModal';
import QuizWinModal from '../../../modals/quizWinModal/QuizWinModal';
import {
  passModalContent,
  promocodeModal,
  quizWinModalContent,
  quizWinnerModalContent,
} from '../../../../constants/copyright-modals';
import AdminCustomModal from '../../../modals/adminCustomModal/AdminCustomModal';
import AddFriendModal from '../../../modals/addFriendModal/AddFriendModal';
import BuyModal from '../../../modals/buyModal/BuyModal';
import ResourceModal from '../../../modals/resourceModal/ResourceModal';
import WordModal from '../../../modals/wordModal/WordModal';
import BuyPrizeModal from '../../../modals/buyPrizeModal/BuyPrizeModal';
import LeaveModal from '../../../modals/leaveModal/LeaveModal';
import TaskCompleteModal from '../../../modals/taskCompleteModal/TaskCompleteModal';
import Faq from '../../../pages/faq/Faq';
import { faqContent } from '../../../../constants/copyright';
import AboutModal from '../../../modals/aboutModal/AboutModal';
import GameTutorial from '../../../modals/gameTutorialModal/GameTutorialModal';
import InactiveGameModal from '../../../modals/inactiveGameModal/InactiveGameModal';
import InactiveAppModal from '../../../modals/inactiveAppModal/InactiveAppModal';
import RulesModal from '../../../modals/rulesModal/RulesModal';
import WModal from '../../../modals/wModal/WModal';
import DrawingResultModal from '../../../features/drawingResult/ui/modal/Modal';
import TutorialModal from '../../../modals/tutorialModal/TutorialModal';
import SlideModal from '../../../modals/slideModal/SlideModal';
import ProcedureGameResultModal from '../../../modals/procedureGameResultModal/ProcedureGameResultModal';
import GameRatingModal from '../../../modals/gameRatingModal/GameRatingModal';
import RatingInfoModal from '../../../modals/ratingInfoModal/RatingInfoModal';
import ConverterModal from '../../../modals/converterModal/ConverterModal';
import TextModal from '../../../modals/textModal/TextModal';
import { Modal } from '../../../pages/wish';
import MyGiftModal from '../../../modals/myGiftModal';
import GiftChoose from '../../../modals/giftChooseModal';
import GiftNotice from '../../../modals/giftNoticeModal/GiftNoticeModal';
import SelectionModal from '../../../modals/selectionModal/SelectionModal';
import SavePostcardModal from '../../../modals/savePostcardModal/SavePostcardModal';
import PassModal from '../../../modals/passModal';
import ShopModal from '../../../modals/shopModal/ShopModal';
import PromocodeModal from '../../../modals/promocodeModal/PromocodeModal';
import PrizeNewSeasonModal from '../../../modals/prizeNewSeasonModal/PrizeNewSeasonModal';
import SeasonBonusModal from '../../../modals/seasonBonusModal/SeasonBonusModal';
import WelcomeBackModal from '../../../modals/welcomeBackModal/WelcomeBackModal';
import SelectCountryModal from '../../../modals/selectCountryModal/SelectCountryModal';
import SelectLangModal from '../../../modals/selectLangModal/SelectLangModal';
import TempPromoModal from '../../../modals/tempPromoModal/TempPromoModal';
import InfoModal from '../../../modals/infoModal';
import { useMemo } from 'react';
import UniversalModal from '../../../modals/universalModal';
import MyGiftImageModal from '../../../modals/myGiftImageModal/MyGiftImageModal';
import OnboardingModal from '../../../modals/onboardingModal/OnboardingModal';
import BuyBeautiesModal from '../../../modals/buyBeautiesModal/BuyBeautiesModal';
import { ConverterToCoinsModal } from '../../../modals/converterToCoinsModal';

export const aliases = () =>
  useMemo(
    () => ({
      pauseModal: {
        Modal: PauseModal,
        name: 'pauseModal',
      },
      profileModal: {
        Modal: ProfileModal,
        name: 'profileModal',
      },
      procedureModal: {
        Modal: ProcedureModal,
        name: 'procedureModal',
      },
      gameResultModal: {
        Modal: GameResultModal,
        name: 'gameResultModal',
      },
      startGameModal: {
        Modal: StartGameModal,
        name: 'startGameModal',
      },
      loseModal: {
        Modal: LoseModal,
        name: 'loseModal',
      },
      winModal: {
        Modal: WinModal,
        name: 'winModal',
      },
      winBeautyBoxModal: {
        Modal: WinBeautyBoxModal,
        name: 'winBeautyBoxModal',
      },
      prizeModal: {
        Modal: Prizes,
        name: 'prizeModal',
      },
      quizStartModal: {
        Modal: QuizStartModal,
        name: 'quizStartModal',
      },
      quizWinModal: {
        Modal: QuizWinModal,
        name: 'quizWinModal',
        props: quizWinModalContent,
      },
      priceWinModal: {
        Modal: QuizWinModal,
        name: 'priceWinModal',
      },
      adminCustomModal: {
        Modal: AdminCustomModal,
        name: 'adminCustomModal',
        props: quizWinnerModalContent,
      },
      addFriendModal: {
        Modal: AddFriendModal,
        name: 'addFriendModal',
      },
      buyModal: {
        Modal: BuyModal,
        name: 'buyModal',
      },
      resourceModal: {
        Modal: ResourceModal,
        name: 'resourceModal',
      },
      wordModal: {
        Modal: WordModal,
        name: 'wordModal',
      },
      buyPrizeModal: {
        Modal: BuyPrizeModal,
        name: 'buyPrizeModal',
      },
      leaveModal: {
        Modal: LeaveModal,
        name: 'leaveModal',
      },
      taskCompleteModal: {
        Modal: TaskCompleteModal,
        name: 'taskCompleteModal',
      },
      faqModal: {
        Modal: Faq,
        props: faqContent,
      },
      aboutModal: {
        Modal: AboutModal,
      },
      gameTutorialModal: {
        Modal: GameTutorial,
      },
      inactiveGameModal: {
        Modal: AboutModal,
      },
      errorModal: {
        Modal: InactiveGameModal,
      },
      inactiveAppModal: {
        Modal: InactiveAppModal,
      },
      rulesModal: {
        Modal: RulesModal,
      },
      wModal: {
        Modal: WModal,
      },
      drawingResultModal: {
        Modal: DrawingResultModal,
      },
      tutorialTaskModal: {
        Modal: TutorialModal,
      },
      slideModal: {
        Modal: SlideModal,
      },
      procedureGameResult: {
        Modal: ProcedureGameResultModal,
      },
      gameRatingModal: {
        Modal: GameRatingModal,
      },
      ratingInfoModal: {
        Modal: RatingInfoModal,
      },
      converterModal: {
        Modal: ConverterModal,
      },
      converterToCoinsModal: {
        Modal: ConverterToCoinsModal,
      },
      textModal: {
        Modal: TextModal,
      },
      wishModal: {
        Modal: Modal,
      },
      myGiftModal: {
        Modal: MyGiftModal,
      },
      myGiftImageModal: {
        Modal: MyGiftImageModal,
      },
      giftChoose: {
        Modal: GiftChoose,
      },
      giftNotice: {
        Modal: GiftNotice,
      },
      selectionModal: {
        Modal: SelectionModal,
      },
      savePostcardModal: {
        Modal: SavePostcardModal,
      },
      passModal: {
        Modal: PassModal,
        props: passModalContent,
      },
      shopModal: {
        Modal: ShopModal,
      },
      promocodeModal: {
        Modal: PromocodeModal,
        props: promocodeModal,
      },
      prizeNewSeasonModal: {
        Modal: PrizeNewSeasonModal,
      },
      seasonBonusModal: {
        Modal: SeasonBonusModal,
      },
      welcomeBackModal: {
        Modal: WelcomeBackModal,
        name: 'welcomeBackModal',
      },
      selectCountryModal: {
        Modal: SelectCountryModal,
        name: 'selectCountryModal',
      },
      selectLangModal: {
        Modal: SelectLangModal,
        name: 'selectLangModal',
      },
      tempPromoModal: {
        Modal: TempPromoModal,
        name: 'tempPromoModal',
      },
      infoModal: {
        Modal: InfoModal,
        name: 'infoModal',
      },
      priceRewardModal: {
        Modal: GiftNotice,
        name: 'priceRewardModal',
      },
      universalModal: {
        Modal: UniversalModal,
        name: 'universalModal',
      },
      onboardingModal: {
        Modal: OnboardingModal,
        name: 'onboardingModal',
      },
      buyBeautiesModal: {
        Modal: BuyBeautiesModal,
        name: 'buyBeautiesModal',
      },
    }),
    [],
  );
